import React from "react";
import { ViewIcon, HideIcon } from "@medentic/polaris-icons";
import { Icon, Box, Button, Tooltip } from "@medentic/polaris-react";
import { usePIIToggle } from "@shared/hooks/clinics/usePIIToggle";
import { useTranslation } from "react-i18next";

import { SudoUser } from "@shared/types/user";
import { useQueryClient } from "@tanstack/react-query";
const PIIToggle: React.FC = () => {
  const { obfuscateSensitiveData, handleToggle, isUpdating } = usePIIToggle();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const sudoUser = queryClient.getQueryData<SudoUser>(["sudo-user"]);
  const tooltipContent = obfuscateSensitiveData
    ? t("common.showSensitiveData")
    : t("common.hideSensitiveData");

  return sudoUser?.sudo ? (
    <></>
  ) : (
    <Box paddingInlineEnd="400" paddingBlockStart="100">
      <Tooltip content={tooltipContent}>
        <Button
          loading={isUpdating}
          variant="tertiary"
          onClick={() => handleToggle(!obfuscateSensitiveData)}
          icon={<Icon source={obfuscateSensitiveData ? HideIcon : ViewIcon} />}
        />
      </Tooltip>
    </Box>
  );
};

export default PIIToggle;
